import React, { PropsWithChildren } from 'react';

import { FullPageSpinner } from '@/components/ui/fullPageSpinner/FullPageSpinner.comp';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

/* THIS IS A QUICK FIX FOR THE ISSUE WITH THE USER CONTEXT NOT BEING READY WHEN THE ROUTES ARE BEING RENDERED */
// TODO: find better solution

export const UserContextVerifier: React.FC<PropsWithChildren> = ({ children }) => {
  const user = useUserContext();

  if (!user.dataReady) {
    return <FullPageSpinner />;
  }

  return <>{children}</>;
};
